"use strict";
//@ts-nocheck
// Auto-generated via `yarn polkadot-types-from-chain`, do not edit
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=augment-api-rpc.js.map